import React from 'react';
import ic_accessories from 'static/images/category-icons/ic_accessories.svg?jsx';
import ic_antiques_design from 'static/images/category-icons/ic_antiques_design.svg?jsx';
import ic_art from 'static/images/category-icons/ic_art.svg?jsx';
import ic_beauty_care from 'static/images/category-icons/ic_beauty_care.svg?jsx';
import ic_books_magazines from 'static/images/category-icons/ic_books_magazines.svg?jsx';
import ic_charity from 'static/images/category-icons/ic_charity.svg?jsx';
import ic_childrens_clothing_shoes from 'static/images/category-icons/ic_childrens_clothing_shoes.svg?jsx';
import ic_clothes from 'static/images/category-icons/ic_clothes.svg?jsx';
import ic_collectibles from 'static/images/category-icons/ic_collectibles.svg?jsx';
import ic_computers_accessories from 'static/images/category-icons/ic_computers_accessories.svg?jsx';
import ic_construction_tools from 'static/images/category-icons/ic_construction_tools.svg?jsx';
import ic_consumer_electronics from 'static/images/category-icons/ic_consumer_electronics.svg?jsx';
import ic_currency from 'static/images/category-icons/ic_currency.svg?jsx';
import ic_dvd_videos from 'static/images/category-icons/ic_dvd_videos.svg?jsx';
import ic_hobby from 'static/images/category-icons/ic_hobby.svg?jsx';
import ic_home_household from 'static/images/category-icons/ic_home_household.svg?jsx';
import ic_jewlry_gemstones from 'static/images/category-icons/ic_jewlry_gemstones.svg?jsx';
import ic_mobile_phone_telecommunications from 'static/images/category-icons/ic_mobile_phone_telecommunications.svg?jsx';
import ic_music from 'static/images/category-icons/ic_music.svg?jsx';
import ic_other from 'static/images/category-icons/ic_other.svg?jsx';
import ic_photo_cameras_optics from 'static/images/category-icons/ic_photo_cameras_optics.svg?jsx';
import ic_postcards_pictures from 'static/images/category-icons/ic_postcards_pictures.svg?jsx';
import ic_shoes from 'static/images/category-icons/ic_shoes.svg?jsx';
import ic_sports_leisure from 'static/images/category-icons/ic_sports_leisure.svg?jsx';
import ic_stamp from 'static/images/category-icons/ic_stamp.svg?jsx';
import ic_tickets_travel from 'static/images/category-icons/ic_tickets_travel.svg?jsx';
import ic_toys_childrens_items from 'static/images/category-icons/ic_toys_childrens_items.svg?jsx';
import ic_watches from 'static/images/category-icons/ic_watches.svg?jsx';
import ic_vehicles_boats_parts from 'static/images/category-icons/ic_vehicles_boats_parts.svg?jsx';
import ic_video_computer_games from 'static/images/category-icons/ic_video_computer_games.svg?jsx';
import ic_handmade_applied_arts from 'static/images/category-icons/ic_handmade_applied_arts.svg?jsx';
import PriceIcon from '@tradera/blueprint/theme/icons/price.svg?jsx';

const categoryIcons = {
    0: PriceIcon, // Rabattkoder
    10: ic_vehicles_boats_parts,
    11: ic_books_magazines,
    12: ic_computers_accessories,
    13: ic_dvd_videos,
    14: ic_photo_cameras_optics,
    15: ic_stamp,
    16: ic_clothes,
    17: ic_consumer_electronics,
    18: ic_hobby,
    19: ic_watches,
    20: ic_antiques_design,
    21: ic_music,
    22: ic_currency,
    23: ic_art,
    24: ic_jewlry_gemstones,
    25: ic_sports_leisure,
    26: ic_mobile_phone_telecommunications,
    27: ic_postcards_pictures,
    28: ic_other,
    29: ic_collectibles,
    30: ic_video_computer_games,
    31: ic_home_household,
    32: ic_construction_tools,
    33: ic_childrens_clothing_shoes,
    34: ic_tickets_travel,
    35: ic_charity,
    36: ic_handmade_applied_arts,
    1612: ic_accessories,
    1623: ic_shoes,
    340736: ic_beauty_care,
    343319: ic_toys_childrens_items
};

export const getCategoryIcon = (categoryId, label) => {
    const IconComponent = categoryIcons[categoryId];
    if (!IconComponent) {
        console.error(
            `IconComponent missing for id: ${categoryId} label: ${label}`
        );
        return null;
    }
    return <IconComponent className="icon icon-lg" />;
};
